import Swal from "sweetalert2";

const throwSuccessMessage = (message: string) => {
    Swal.fire({
        toast: true,
        icon: 'success',
        titleText: '¡Éxito!',
        text: message,
        showConfirmButton: false,
        timer: 5000,
        allowEscapeKey: true,
        background: '#fff',
        color: '#000',
        iconColor: '#ff6600',
        timerProgressBar: true,
        position: 'top-end',
        target: '.v-application',
    }).then(r => r)
}

export default throwSuccessMessage;